if ($('.fotorama').length) {
  $(document).ready(function() {
    const fotoramaDiv = $('.fotorama').fotorama();
    const fotorama = fotoramaDiv.data('fotorama');

    $(document).on( "click", ".fotorama:not(.fotorama--fullscreen) .fotorama__stage__shaft .fotorama__active:not(.fotorama__stage__frame--video) img", function() {
      fotorama.show(fotorama.activeIndex-1)
      fotorama.requestFullScreen()
    });

    fotoramaDiv.on('fotorama:showend',function (e, fotorama, extra) {
      $('.fotorama__stage__frame').removeClass('video-active-gallery');
      if ('video' in fotorama.activeFrame) {
        setTimeout(function() {
          fotorama.playVideo();
          $('.fotorama--fullscreen .fotorama__wrap').removeClass('fotorama__wrap--video');
          $('.fotorama--fullscreen .fotorama__stage__shaft .fotorama__active').addClass('video-active-gallery');
        }, 1000);
      }
    })

    fotoramaDiv.on('fotorama:fullscreenexit',function (e, fotorama, extra) {
      $('.fotorama__stage__frame').removeClass('video-active-gallery');
    })

    $('body').on('keyup', function (e) {
        if ($('.fotorama--fullscreen').length && e.which === 27) { // detect if it is **Esc** button
          $('.fotorama__stage__frame').removeClass('video-active-gallery');
          fotorama.cancelFullScreen()
        }
    });
  });
}

var subscriptionButtonEl = document.querySelector("#subscriptionButton");
var buyOnceButtonEl = document.querySelector("#buyOnceButton");

if (subscriptionButtonEl) {
  subscriptionButtonEl.addEventListener("click", function(){
    onSubscriptionClick(false);
  }, false);
}
if (buyOnceButtonEl) {
  buyOnceButtonEl.addEventListener("click", function(){
    onSubscriptionClick(true);
  }, false);
}

if (subscriptionButtonEl) {
  setTimeout(function() {
    onSubscriptionClick(true);
  },500)
}

function onSubscriptionClick(isBuyOnceClicked) {
  const subscriptionList = document.getElementById("appstle-widget-template");
  const buyOnce = document.getElementById("buyOnceContainer");
  const subscriptionContainer = document.getElementById("subscriptionContainer");
  const style = window.getComputedStyle(subscriptionList)

  const allSubscriptions = document.getElementsByClassName("appstle_input_wrapper")
  const priceElement = document.querySelector('.product-price--original[data-js-product-price-original]');
  const priceElementCustom = document.querySelector('.product-price--original-custom[data-js-product-price-original]');
  const metaPriceElement = document.querySelector('meta[property="og:price:amount_cents"]');
  const defaultPrice = parseFloat(metaPriceElement.getAttribute('content'));
  if (!isBuyOnceClicked && style.getPropertyValue('display') == 'none') {
    buyOnce.classList.remove('active');
    subscriptionContainer.classList.add('active')
    subscriptionList.style.display = "block";
    allSubscriptions[1].getElementsByTagName("input")[0].click()
    const newPrice = (defaultPrice * 0.90);
    priceElement.textContent = formatMoney(newPrice, KROWN.settings.shop_money_format_with_currency);
    priceElementCustom.textContent = formatMoney(newPrice, KROWN.settings.shop_money_format_with_currency);
  } else {
    subscriptionList.style.display = "none";
    buyOnce.classList.add('active');
    subscriptionContainer.classList.remove('active')
    allSubscriptions[0].getElementsByTagName("input")[0].click()
    priceElement.textContent = formatMoney(defaultPrice, KROWN.settings.shop_money_format_with_currency);
    priceElementCustom.textContent = formatMoney(defaultPrice, KROWN.settings.shop_money_format_with_currency);
  }
}